import React, {useEffect, useRef, useState} from "react";
import { NavigationService } from "../../services/NavigationService";
import ReportTable from "../../components/ReportTable/ReportTable";
import BeneficiaryDataLoaderReport from "../../components/Reports/BeneficiaryDataLoaderReport";
import DimensionamentoReport from "../../components/Reports/DimensionamentoReport";
import EstimativaReport from "../../components/Reports/EstimativaReport";
import NeedsByServiceTypeReport from "../../components/Reports/NeedsByServiceTypeReport";
import RootCauseReport from "../../components/Reports/RootCauseReport";
import AverageProviderReport from "../../components/Reports/AverageProviderReport";
import { useLocation } from "react-router-dom";
import CollaboratorsDistributionReport from "../../components/Reports/CollaboratorsDistributionReport";
import {LogsServices} from "../../services/LogsServices";

const componentsMap = [
  {
    name: "Dados dos beneficiarios",
    component: <BeneficiaryDataLoaderReport />,
    customName: null,
  },
  {
    name: "Leitos Hospitalares",
    component: <EstimativaReport />,
    customName: "Estimativas Epidemiológicas",
  },
  {
    name: "Leitos Hospitalares",
    component: <DimensionamentoReport />,
    customName: "Dimensionamento por Complexidade",
    subTitle: "Relatório por Complexidade Assistencial"
  },
  {
    name: "Leitos Hospitalares",
    component: (returnContext) => <NeedsByServiceTypeReport returnContext={returnContext} />,
    customName: "Dimensionamento por Especialidades",
  },
  {
    name: "Leitos Hospitalares",
    component: <RootCauseReport />,
    customName: "Gestão de Rede",
  },
  {
    name: "Dados dos beneficiarios",
    component: <AverageProviderReport />,
    customName: "Utilização da Operadora",
  },
  {
    name: "Profissionais Não Médicos Ambulatoriais",
    component: <CollaboratorsDistributionReport />,
    customName: "Distribuição da Rede Prestadora",
  },
];

const transformToNavigation = (steps) => {
  return steps.map(({ stepName, completed, unlocked }) => {
    const navItem = {
      stepName,
      completed,
      unlocked,
    };

    componentsMap.forEach((item) => {
      if (item.name === stepName) {
        if (navItem.direct) navItem.direct.push(item);
        else {
          navItem.direct = [];
          navItem.direct.push(item);
        }
        if (item.customName) {
          navItem.displayName = item.customName;
        } else {
          navItem.displayName = stepName;
        }
        navItem.displayName = item.customName || stepName;
      }
    });

    return navItem;
  });
};

const Reports = () => {
  const [navigation, setNavigation] = useState([]);
  const [selectedStep, setSelectedStep] = useState();
  const location = useLocation();
  const containerRef = useRef(null);

  useEffect(() => {
    if (location.state?.selectedStep) {
      setSelectedStep(location.state.selectedStep);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedStep && containerRef){
      containerRef.current.scrollTop = 0
    }
  }, [selectedStep]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiResponse = await NavigationService.getNavigationSteps();
        const transformedNavigation = transformToNavigation(apiResponse);
        setNavigation(transformedNavigation);
      } catch (error) {
        console.error("Erro ao obter os passos de navegação:", error);
      }
    };

    fetchData();
  }, []);

  const handleSetSelectedStep = (step) => {
    LogsServices.postLog(`Ação: Acesso ao relatório ${step.customName || step.name}`);
    setSelectedStep(step);
  };

  const handleReturn = () => {
    if (location.state?.returnContext) {
      const { selectedStep: returnStep, selectedCity, cityObj, reportType } = location.state.returnContext;
      
      setSelectedStep({
        ...returnStep,
        returnContext: {
          selectedCity,
          cityObj,
          reportType
        }
      });
      
      window.history.replaceState({}, document.title);
    } else {
      setSelectedStep(null);
    }
  };

  const handleGetDirect = (navigation) => {
    const res = navigation.find((step) => {
      if (step.stepName === selectedStep.name) {
        return step;
      } else return null;
    });

    if (!res) return;

    return res.direct.find(
      (direct) => direct.customName === selectedStep.customName
    );
  };

  return (
    <div
      ref={containerRef}
      className="w-screen h-screen flex flex-col justify-start overflow-x-hidden overflow-y-auto bg-gray-50">
      {selectedStep && handleGetDirect(navigation) && (
        <div className="sticky w-full top-0 bg-white px-6 py-4 z-40 shadow-sm border-b border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-y-4 max-w-7xl mx-auto">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-emerald-100 rounded-lg">
                <svg
                  className="h-6 w-6 text-emerald-700"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
                  <span className="text-emerald-700 font-bold">
                    {handleGetDirect(navigation).customName ||
                      selectedStep.name}
                  </span>
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  {selectedStep.subTitle ?? "Relatório detalhado do sistema"}
                </p>
              </div>
            </div>
            <button
              onClick={handleReturn}
              className="bg-emerald-600 text-white px-6 py-2.5 rounded-lg hover:bg-emerald-700 duration-200 ease-in-out shadow-md hover:shadow-lg transition-all flex items-center space-x-2"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              <span>Voltar aos Relatórios</span>
            </button>
          </div>
        </div>
      )}
      <div
        className="w-full h-[90%] flex flex-col justify-start items-center bg-gray-50 px-4 py-8">
        {selectedStep && handleGetDirect(navigation) ? (
          <div className="w-full bg-white rounded-lg shadow-sm">
            <div className="w-full h-full">
              {handleGetDirect(navigation).customName ===
              "Gestão de Rede" ? (
                <RootCauseReport
                  rowData={selectedStep?.rowData}
                  causeAndActionRowData={selectedStep?.causeAndActionRowData}
                  editExistent={selectedStep?.editExistent}
                  viewOnly={selectedStep?.viewOnly}
                />
              ) : (
                <div className="md:p-6 p-0">
                  {typeof handleGetDirect(navigation).component === 'function' 
                    ? handleGetDirect(navigation).component(selectedStep?.returnContext)
                    : handleGetDirect(navigation).component}
                </div>
              )}
            </div>
          </div>
        ) : (
          <ReportTable
            navigation={navigation}
            selectedStep={handleSetSelectedStep}
          />
        )}
      </div>
    </div>
  );
};

export default Reports;
